import type { Components } from '@mui/material/styles';

export default function MuiStepButton(): Components['MuiStepButton'] {
  return {};
}
